import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// components
import CardTitlePart from '../../parts/CardTitlePart';
import TextAreaCharacterLimit from '../../parts/TextAreaCharacterLimit';
import TextCTA from '../../layout/buttons/TextCTA';

// actions
import { submitDeliveryInstructions } from '../../actions/delivery';
// componenets
import OverlayLoader from '../../parts/OverlayLoader';
// services
import { gtmSimplePageLoadEvent } from '../../services/gtmService';


class _DeliveryInstructionsCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deliveryInstructions: '',
      deliveryInstructionsRequired: 'yes',
      preventChangeOnLimit: false,
      saving: false
    };

    if (props.parentCardName && props.parentCardName === 'DeliveryFlow') {
      gtmSimplePageLoadEvent(`${props.parentCardName} page ${props.thisCardName}`);
    }
    this.onDeliveryInstructionsChanged = this.onDeliveryInstructionsChanged.bind(this);
    this.submitDeliveryInstructions = this.submitDeliveryInstructions.bind(this);
    this.deliveryInstructionsAreInvalid = this.deliveryInstructionsAreInvalid.bind(this);
    this.deliveryInstructionsAreRequired = this.deliveryInstructionsAreRequired.bind(this);
    this.onDeliveryInstructionsRequiredChanged = this.onDeliveryInstructionsRequiredChanged.bind(this);
  }

  onDeliveryInstructionsChanged(deliveryInstructions) {
    this.setState({ deliveryInstructions });
  }

  onDeliveryInstructionsRequiredChanged($evt) {
    this.setState({ deliveryInstructionsRequired: $evt.target.value });
  }

  deliveryInstructionsAreRequired() {
    return this.state.deliveryInstructionsRequired === 'yes';
  }

  deliveryInstructionsAreInvalid() {
    return this.deliveryInstructionsAreRequired()
      && (this.state.deliveryInstructions.length === 0
        || this.state.deliveryInstructions.length > this.props.deliveryInstructionsCharacterLimit);
  }

  submitDeliveryInstructions() {
    this.setState({ saving: true });

    const { submitDeliveryInstructions, id, orderIdx, groupId,
      pushQueue, queueMessage, dismissCard } = this.props;

    submitDeliveryInstructions(id, orderIdx,
      this.deliveryInstructionsAreRequired(),
      this.state.deliveryInstructions,
      groupId, pushQueue, queueMessage
    )
      .then((data) => {
        if (data.Result) dismissCard();
        else this.setState({ saving: false });
      })
      .catch(() => this.setState({ saving: false }));
  }

  render() {
    const { orderNo, orderRef } = this.props;

    return (
      <section>
        <CardTitlePart title={this.props.title} />

        <div className="u-pale-grey-bg u-padding-small">

          <div className="u-margin-bottom-small h4 u-text-center fs-emeric-light">
            Do you have any special delivery instructions?
          </div>

          <fieldset>
            <label
              htmlFor="deliveryRequiredYes"
              className="u-text-center u-display-inline-half"
            >
              Yes
              <input
                id="deliveryRequiredYes"
                type="radio"
                name="deliveryRequiredYes"
                className="u-radio-vertical-middle u-margin-left-small"
                value="yes"
                onChange={this.onDeliveryInstructionsRequiredChanged}
                checked={this.deliveryInstructionsAreRequired()}
              />
            </label>

            <label
              htmlFor="deliveryRequiredNo"
              className="u-text-center u-display-inline-half"
            >
              No
              <input
                id="deliveryRequiredNo"
                type="radio"
                name="deliveryRequiredNo"
                className="u-radio-vertical-middle u-margin-left-small"
                value="no"
                onChange={this.onDeliveryInstructionsRequiredChanged}
                checked={!this.deliveryInstructionsAreRequired()}
              />
            </label>
          </fieldset>

          <TextAreaCharacterLimit
            rows="5"
            containerClassname={'u-margin-top-small'}
            textareaClassname={'o-fullwidth u-placeholder-padding-small u-padding-tiny fs-emeric-light'}
            disabled={!this.deliveryInstructionsAreRequired()}
            placeholderText={this.props.deliveryInstructionsPlaceholderText}
            value={this.state.deliveryInstructions}
            characterLimit={this.props.deliveryInstructionsCharacterLimit}
            onChange={this.onDeliveryInstructionsChanged}
            preventChangeOnLimit={this.state.preventChangeOnLimit}
          />
        </div>

        <div className="u-clearfix c-event-feed__card__splitter u-flex-justify-end">

          <OverlayLoader active={this.state.saving} scale={0.5} />

          <TextCTA
            text={'Next'}
            position={'right'}
            align={'right'}
            type={'confirm'}
            disabled={this.deliveryInstructionsAreInvalid() || this.state.saving}
            onBtnClick={this.submitDeliveryInstructions}
          />
        </div>

        <div className="u-padding-y-small u-text-center c-event-feed__card__extra-info">
          <strong>Order Number:</strong> {`${orderRef}/${orderNo}`}
        </div>

      </section>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  submitDeliveryInstructions
}, dispatch);

export default connect(null, mapDispatchToProps)(_DeliveryInstructionsCard);



// WEBPACK FOOTER //
// ./src/cards/templates/DeliveryInstructionsCard.js